var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2519 14.772C26.2519 13.7648 26.1685 13.0298 25.9881 12.2676H14.252V16.8136H21.1408C21.0019 17.9434 20.2519 19.6448 18.5853 20.7881L18.5619 20.9403L22.2726 23.7574L22.5297 23.7826C24.8908 21.6456 26.2519 18.5014 26.2519 14.772Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2506 26.7502C17.6256 26.7502 20.4589 25.6612 22.5284 23.7829L18.5839 20.7884C17.5284 21.5098 16.1117 22.0134 14.2506 22.0134C10.9451 22.0134 8.13959 19.8765 7.1395 16.9229L6.99291 16.9351L3.13444 19.8615L3.08398 19.9989C5.13951 24.0006 9.36173 26.7502 14.2506 26.7502Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14078 16.9227C6.8769 16.1605 6.72418 15.3438 6.72418 14.4999C6.72418 13.656 6.8769 12.8394 7.1269 12.0771L7.11991 11.9148L3.21308 8.94141L3.08525 9.00099C2.23807 10.6616 1.75195 12.5263 1.75195 14.4999C1.75195 16.4735 2.23807 18.3382 3.08525 19.9988L7.14078 16.9227Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2507 6.98663C16.5979 6.98663 18.1812 7.98024 19.084 8.81057L22.6118 5.435C20.4452 3.46139 17.6257 2.25 14.2507 2.25C9.36176 2.25 5.13952 4.99942 3.08398 9.00106L7.12564 12.0772C8.13962 9.1236 10.9452 6.98663 14.2507 6.98663Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.cf6fbf0800d41b78ad3384cf2fd69fd9.svg";
export { ForwardRef as ReactComponent };